import styled from 'styled-components';
import { COLORS } from 'constants/design';

export const NoResults = styled.div`
  background-color: ${COLORS.WHISPER};
  width: 95%;
  margin: 0 auto;
  padding: 24px 0 24px 24px;
`;

export const CallToAction = styled.div`
  margin-top: 10px;
  .buttonIcon {
    width: 15px;
    margin: 0 7px;
    fill: #fff;
  }
  #primary-button-style {
    margin-right: 15px;
  }
`;

export const Content = styled.div`
  font-size: 14px;
  color: ${({ color }) => (color ? color : `${COLORS.GREY}`)};
  padding: 10px 0;
`;

export const SupportDocumentContainer = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 30px;
  margin-left: 20px;
`;
